module.exports = __webpack_public_path__ + "img/jira.e7e1a3f5.png";